// Module
var code = "<div ng-controller=\"secureController as secureCtrl\"> <presentation-inner-viewer></presentation-inner-viewer> </div> ";
// Exports
module.exports = code;